import { render, staticRenderFns } from "./RouteStops.vue?vue&type=template&id=b31c294a&"
import script from "./RouteStops.vue?vue&type=script&lang=js&"
export * from "./RouteStops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports